import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { IRequestDemo } from '../../shared/models/RequestDemo';
import { LoaderService } from '../../shared/providers/loader.service';
import { ToastService } from '../../shared/providers/toast.service';
import { UserManagerService } from '../../shared/providers/user-manager.service';

@Component({
  selector: 'app-seller-learn-more',
  templateUrl: './seller-learn-more.component.html',
  styleUrls: ['./seller-learn-more.component.css']
})

export class SellerLearnMoreComponent implements OnInit {
 
  constructor(public authentication: AuthenticationService, private Loader: LoaderService, private _userManagerService: UserManagerService, private Toast: ToastService) { }
  user: any;
  RequestDemo = {} as IRequestDemo;
  ngOnInit(): void {
    this.user = this.authentication.user;
  }

  sendMail() {
    if (this.user != null) {
      this.Loader.display(true);
      this.RequestDemo.DashboardType = "SellerDashboard";
      this.RequestDemo.UserId = this.user.Id;
      this._userManagerService.RequestDemo(this.RequestDemo).subscribe(response => {
        if (response) {
          this.Toast.addToast({ title: 'Success', msg: 'You have successfully sent a request for the demo of the seller dashboard.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        }
        else {
          this.Toast.addToast({ title: 'Error', msg: 'An error Occurred while requesting the demo', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      });
      this.Loader.display(false);
    }
  }
}
